import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  return {
    root: _objectSpread({}, props.isOneQuestionAtATime && {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      margin: "".concat(componentTheme.rootMargin, " auto"),
      maxWidth: componentTheme.rootMaxWidth
    }),
    body: {
      marginTop: componentTheme.bodyMargin,
      marginLeft: '0',
      marginRight: '0'
    },
    overlayBody: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh'
    },
    overlayItem: {
      verticalAlign: 'baseline'
    }
  };
};
export default generateStyle;